import { tassign } from 'tassign';

// Own feature
import { User } from '../../user/model/user';

import {
  // -- 1. Data from Backend --------------------
  USER_CHANGE_CURRENT,
  BACKEND_VERSION,
  USER_ROLES,
} from './actions';

export interface IUserState {
   // -- 1. Data from Backend --------------------
   currentUser: User;
   backendVersion: string;
   userRoles: string[];
}

export const USER_INITIAL_STATE: IUserState = {
   // -- 1. Data from Backend --------------------
   currentUser: null,
   backendVersion: 'unknown',
   userRoles: [],
};

export function userReducer(state: IUserState = USER_INITIAL_STATE, action): IUserState {
  switch (action.type) {
    // -- 1. Data from Backend --------------------
    case USER_CHANGE_CURRENT: return changeCurrent(state, action);
    case BACKEND_VERSION: return backendVersion(state, action);
    case USER_ROLES: return userRoles(state, action);
    default:
      console.error('Unknown action type in userReducer', action.type);
  }

  return state;
}

// ------------------------------------------------------------------------------------------------
// -- 1. Data from Backend ------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
function changeCurrent(state, {type: type, user: user}): IUserState {
  return tassign(state, {
    currentUser: user
  });
}

function backendVersion(state, {type: type, payload: {version: version}}): IUserState {
  return tassign(state, {
   backendVersion: version
  });
}

function userRoles(state, {type: type, roles: roles}): IUserState {
  return tassign(state, {
    userRoles: roles
  });
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/user/store/store.ts